import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker"; // Убедитесь, что библиотека установлена: npm install react-datepicker
import "react-datepicker/dist/react-datepicker.css";
import { fetchMovies } from "../../functions/api";
import FilmCard from "../cards/FilmCard";
import az_flag from "../../assets/img/Azerbaijan.png";
import tr_flag from "../../assets/img/Turkey.png";
import ru_flag from "../../assets/img/Russia.png";
import uk_flag from "../../assets/img/UK.png";
import Loader from "../Loader";
// import { useTranslation } from "react-i18next";

const SuIdmanSarayi = () => {
  const [movies, setMovies] = useState([]);
  const [filteredMovies, setFilteredMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  // const { t } = useTranslation();

  useEffect(() => {
    const getMovies = async () => {
      try {
        const data = await fetchMovies();
        const filteredData = data.filter(
          (movie) => movie.branch === "Su İdman Sarayı"
        );
        const sortedMovies = filteredData.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );

        setMovies(sortedMovies);
        setFilteredMovies(sortedMovies);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching movies:", error);
      }
    };

    getMovies();
  }, []);

  const filterByDate = (date) => {
    setSelectedDate(date);

    if (!date) {
      setFilteredMovies(movies);
      return;
    }

    const filtered = movies.filter(
      (movie) => new Date(movie.date).toDateString() === date.toDateString()
    );
    setFilteredMovies(filtered);
  };

  const getFlags = (movie) => {
    const flags = [];
    if (movie?.az_lang) flags.push(az_flag);
    if (movie?.tr_lang) flags.push(tr_flag);
    if (movie?.ru_lang) flags.push(ru_flag);
    if (movie?.en_lang) flags.push(uk_flag);
    return flags;
  };

  if (loading) {
    return <Loader />;
  }

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div>
      <div className="container">
        <div className="mb-8">
          <DatePicker
            selected={selectedDate}
            onChange={(date) => filterByDate(date)}
            className="border border-purple border-[2px] bg-main text-white p-4 rounded-[12px] outline-none"
            placeholderText='Tarix seçin'
          />
        </div>
      </div>

      {filteredMovies.length === 0 ? (
        <p className="text-white">Seçdiyiniz tarixə seans yoxdur.</p>
      ) : (
        <div className="w-full container grid grid-cols-4 gap-3 max-[450px]:grid-cols-1">
          {filteredMovies.map((movie) => (
            <FilmCard
              key={movie.id}
              img={movie.poster}
              color="purple"
              title={movie.title}
              time={movie.time}
              date={formatDate(movie.date)}
              centers={movie.branch}
              flags={getFlags(movie)}
              pufik_lang={movie.pufik_lang}
              iticket_link={movie.iticket_link}
            // vip_status={movie.vip_status ? 1 : 2}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SuIdmanSarayi;
